import { Stack, Avatar, Typography, Skeleton, useTheme } from '@mui/material';
import { IInstitution } from '../accountTypeData';

interface RecommendationCardProps {
  institution: IInstitution;
  icon: React.ReactNode;
  onClick?: (selected: IInstitution) => void;
  isLoading?: boolean;
}

const RecommendationCard = ({
  institution,
  icon,
  onClick,
  isLoading = false,
}: RecommendationCardProps) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  const height = '100px';

  if (isLoading) {
    return (
      <Skeleton
        variant='rounded'
        height={height}
        width='100%'
      />
    );
  }

  return (
    <Stack
      direction='row'
      height={height}
      alignItems='center'
      px={2}
      gap={2}
      sx={{
        border: '1px solid rgba(0,0,0,0.09)',
        bgcolor: 'rgba(0,0,0,0.04)',
        borderRadius: '4px',
        cursor: 'pointer',
        '&:hover': {
          bgcolor: 'rgba(0,0,0,0.08)',
        },
      }}
      onClick={() => onClick?.(institution)}
    >
      <Avatar
        sx={{
          width: 60,
          height: 60,
          bgcolor: isDarkMode ? 'rgba(255, 255, 255, 0.08)' : 'white',
        }}
      >
        {icon}
      </Avatar>
      <Typography variant='h6'>{institution.label}</Typography>
    </Stack>
  );
};

export default RecommendationCard;
